import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["aria-selected", "data-testid", "onClick"]
const _hoisted_3 = ["data-testid"]

import type { PriorityTab } from '@/Network/Types/Responses/PriorityPaymentsResponses'

/** Q9: "Todos" é o padrão; na aba de um tipo vale o SLA daquele tipo (§3.4). */

export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsTabs',
  props: {
    tab: {},
    counts: {},
    testId: { default: 'priority-payments-tabs' }
  },
  emits: ["update:tab"],
  setup(__props: any, { emit }) {

const props = __props;

const TAB_OPTIONS: { value: PriorityTab; label: string }[] = [
  { value: 'ALL', label: 'Todos' },
  { value: 'IN_CASH', label: 'À vista' },
  { value: 'ANTECIPE', label: 'Antecipe' }
]





function onSelect(value: PriorityTab): void {
  if (value !== props.tab) emit('update:tab', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "tablist",
    "aria-label": "Tipo de pagamento",
    class: "inline-flex w-fit max-w-full flex-wrap gap-1 rounded-lg border border-lightGray30 bg-white p-1",
    "data-testid": _ctx.testId
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TAB_OPTIONS, (option) => {
      return _createElementVNode("button", {
        key: option.value,
        type: "button",
        role: "tab",
        class: _normalizeClass(["flex items-center gap-1.5 rounded-md px-3 py-1.5 text-[13px] font-medium", 
        _ctx.tab === option.value ? 'bg-primary text-white' : 'text-neutral50 hover:bg-lightGray30/40'
      ]),
        "aria-selected": _ctx.tab === option.value,
        "data-testid": `${_ctx.testId}-${option.value}`,
        onClick: ($event: any) => (onSelect(option.value))
      }, [
        _createTextVNode(_toDisplayString(option.label), 1),
        (_ctx.counts)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["rounded-full px-1.5 text-[11px] tabular-nums", _ctx.tab === option.value ? 'bg-white/20' : 'bg-lightGray30']),
              "data-testid": `${_ctx.testId}-${option.value}-count`
            }, _toDisplayString(_ctx.counts[option.value]), 11, _hoisted_3))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2)
    }), 64))
  ], 8, _hoisted_1))
}
}

})